// GetCoins returns global data for coins
export const CoinsService_GetCoinsLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetCoins);
CoinsService_GetCoinsLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoins" as const;

// GetCoinsHistory returns coins history sections (e.g. transactions)
export const CoinsService_GetCoinsHistoryLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetCoinsHistory);
CoinsService_GetCoinsHistoryLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoinsHistory" as const;

// GetCoinsHistoryHeader returns data for rendering a coins history header
export const CoinsService_GetCoinsHistoryHeaderLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetCoinsHistoryHeader);
CoinsService_GetCoinsHistoryHeaderLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoinsHistoryHeader" as const;

// GetCoinsHistoryTransactionByOrderId returns a coins history transaction by order id
export const CoinsService_GetCoinsHistoryTransactionByOrderIdLazy = () =>
  import("./service.grpc").then(
    (m) => m.CoinsService_GetCoinsHistoryTransactionByOrderId
  );
CoinsService_GetCoinsHistoryTransactionByOrderIdLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoinsHistoryTransactionByOrderId" as const;
